import {LogoWrapper, Wrapper} from './styled';
import {LoadingScreenProps} from './types';

export const LoadingScreen = (props: LoadingScreenProps) => (
    <Wrapper>
        <LogoWrapper />
        <div>{props.children}</div>
    </Wrapper>
);
